import { render } from "./Months.vue?vue&type=template&id=0c54fba0&scoped=true"
import script from "./Months.vue?vue&type=script&lang=js"
export * from "./Months.vue?vue&type=script&lang=js"

import "./Months.vue?vue&type=style&index=0&id=0c54fba0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c54fba0"]])

export default __exports__